import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import { RootState } from '../../../reducers';
import * as actionsJourney from '../../../actions/journey1';
import * as actionsSujet from '../../../actions/sujet';
import './CreationOrder.scss';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import { formConfig } from './formConfig';
import { getIcon, spottypes } from '../../../utils/mappings';
import { Button, EButtonType, Input } from '@repo/apg-ui';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import { EValidationTestType } from '../../../utils/validationConfigs';
import { testsFailed } from '../../../utils/validationTests';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import SpinnerV2 from '../../../components/SpinnerV2';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney: any;
  actionsSujet: any;
  campaignDetails: any;
  orderCompanies: any;
  intl: any;
  isDigital: boolean;
  keycloakReady: any;
  locales: any;
  loading: any;
  chosenOrderCompany: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
}

type InputTypes =
  | 'phone'
  | 'street'
  | 'city'
  | 'gender'
  | 'firstname'
  | 'name'
  | 'email'
  | 'zipcode'
  | 'nr'
  | 'spottype'
  | 'formatsObj'
  | 'orderCompany'
  | 'checkboxControl';

const MAX_FILE_SIZE = 100000000; // 100MB

const CreationOrder = (props: Props) => {
  const [campaign, setCampaign] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const [stateData, setStateData] = React.useState<any>({
    arts: Object.values(spottypes),
    spottype: null,
    orderCompany: null,
    addressOption: 0,
    produktionSagentur: null,
    firstname: '',
    name: '',
    street: '',
    nr: '',
    zipcode: '',
    city: '',
    email: '',
    phone: '',
    gender: '',
    formatsObj: null,
    submittingCustomerDetails: false,
    upload: {},
    textarea: null,
    fileName: '',
    checkboxControl: false,
  });

  const [errorListInputs, setErrorListInputs] = React.useState({
    formatsObj: false,
    spottype: false,
    orderCompany: false,
    firstname: false,
    name: false,
    street: false,
    nr: false,
    zipcode: false,
    city: false,
    email: false,
    phone: false,
    gender: false,
    checkboxControl: true,
  });

  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const campaignId = params.campaignId;
    setIsLoading(true);
    const payload = {
      type: props.isDigital ? 3 : 1,
    };

    if (props.keycloakReady) {
      props.actionsSujet.getCampaignDetails({ number: campaignId }).then((campaignDetails) => {
        if (campaignDetails) {
          props.actionsSujet.orderCompanies(payload).then((resOrder: { number: any }[]) => {
            const newStateData = {
              ...stateData,
              orderCompany: resOrder[0].number,
            };
            setCampaign(campaignDetails);
            if (campaignDetails) {
              const formatsArr = [...new Set([...campaignDetails.products.map((p: { format: any }) => p.format)])];
              const formatsObj = {};
              formatsArr.forEach((format) => {
                formatsObj[format] = { value: false, format };
              });
              newStateData.formatsObj = formatsObj;
            }
            setStateData(newStateData);
            setIsLoading(false);
            validationInput('spottype')();
          });
        }
      });
    }
  }, []);

  const prepareArtsOptions = () => {
    const getLabel = (link: string, name: string) =>
      link ? (
        <div className={'video-container'}>
          <video controls>
            <source src={link} type='video/mp4' />
          </video>
          <span>{name}</span>
        </div>
      ) : (
        name
      );

    return stateData.arts
      ? stateData.arts.map(({ name, id, link }) => ({
          label: getLabel(link, name),
          type: 'radio',
          name: 'artType',
          value: id,
          onChange: (name, art) => {
            setStateData({ ...stateData, spottype: art });
            validationInput('spottype')(art);
          },
        }))
      : [];
  };

  const postCreationOrder = () => {
    if (stateData.addressOption === 1) {
      if (checkFormByDefault().then((res) => res)) {
        return;
      }
    } else {
      validationInput('orderCompany')();
      validationInput('spottype')();
      validationInput('checkboxControl')();
      checkFormatsObj();
    }

    if (!stateData.orderCompany || errorListInputs.formatsObj || errorListInputs.spottype) {
      return;
    }

    const {
      formatsObj,
      upload,
      orderCompany,
      textarea,
      addressOption,
      gender,
      name,
      firstname,
      street,
      zipcode,
      city,
      phone,
      email,
      spottype,
    } = stateData;
    const {
      userDataEC: { userInfo },
      isDigital,
      actionsSujet: { postCreationOrder },
    } = props;

    const formats = Object.keys(formatsObj).map((key) => formatsObj[key].format);
    const documents = Object.keys(upload).map((key) => upload[key].urn);
    const payload = {
      it21number: campaign.campaigndata.number,
      formats: [...formats],
      documents: [...documents],
      creationcompanyid: orderCompany,
      comment: textarea,
      otherresponsible: addressOption,
      title: userInfo.title,
      name: userInfo.name,
      firstname: userInfo.firstname,
      street: userInfo.street,
      zipcode: userInfo.zipcode,
      city: userInfo.city,
      phone: userInfo.phone,
      email: userInfo.email,
    };

    if (addressOption === 1) {
      payload['title'] = gender === 'Frau' || gender === 'Madame' || gender === 'Sig.ra' || gender === 'Ms' ? 0 : 1;
      payload['name'] = name;
      payload['firstname'] = firstname;
      payload['street'] = street;
      payload['zipcode'] = zipcode;
      payload['city'] = city;
      payload['phone'] = phone;
      payload['email'] = email;
    }

    if (isDigital) {
      payload['spottype'] = parseInt(spottype);
      payload['type'] = 1;
    }

    postCreationOrder(payload).then((res) => {
      if (res && res.data) {
        navigate({
          pathname: `/campaign/${res.data.it21campaign}/${
            isDigital ? 'creation-order-digital' : 'creation-order'
          }/${res.data.id}`,
        });
      }
    });
  };

  const prepareAddressOptions = () => {
    return [
      {
        val: 0,
        text: <FormattedMessage id='as.creationOrder.address1' defaultMessage='Aktuelle Kontaktadresse' />,
      },
      {
        val: 1,
        text: <FormattedMessage id='as.creationOrder.otherAddress' defaultMessage='Andere Kontaktadresse angeben:' />,
      },
    ].map((addressText) => {
      return {
        label: addressText.text,
        type: 'radio',
        name: 'address',
        value: addressText.val,
        onChange: (name, addressOption) => setStateData({ ...stateData, addressOption }),
      };
    });
  };

  const onChangeFormat = (stateVal, attrId) => {
    const newFormats = { ...stateData.formatsObj };
    newFormats[attrId].value = stateVal;
    setStateData({ ...stateData, formatsObj: newFormats });
  };

  // const prepareOrderOptions = () => {
  //     let options = [];
  //     const orders = props.orderCompanies;
  //
  //     if (orders && Object.keys(orders).length) {
  //         Object.keys(orders).forEach(opt => {
  //             options.push({
  //                 dropdownLabel: orders[opt].name,
  //                 id: orders[opt].number,
  //             });
  //         });
  //     }
  //     return options;
  // };

  const validationInput =
    (inputName: InputTypes, validationTests: EValidationTestType[] = [EValidationTestType.hasValue]) =>
    (_value?) => {
      const value = _value || stateData[inputName];
      let testsFailedArr: EValidationTestType[];

      if (inputName === 'checkboxControl') {
        testsFailedArr = testsFailed([EValidationTestType.isTrue], value);
      } else {
        testsFailedArr = testsFailed(validationTests, value);
      }
      setErrorListInputs({ ...errorListInputs, [inputName]: testsFailedArr.length > 0 });
    };

  const isDisableButton = () => {
    if (loading && loading.upload) {
      return true;
    }

    if (Number(stateData.addressOption) === 1) {
      return Object.values(errorListInputs).join('-').includes('true');
    } else {
      const { orderCompany, spottype, formatsObj, checkboxControl } = errorListInputs;

      return `${orderCompany}-${spottype}-${formatsObj}-${checkboxControl}`.includes('true');
    }
  };

  const checkFormatsObj = () => {
    let { formatsObj } = stateData;
    const resArr = [];
    let isValid: boolean;

    if (!isEmpty(formatsObj)) {
      Object.values(formatsObj).forEach((item: any) => resArr.push(item.value === true));
      isValid = resArr.some((res) => res === true);
      setErrorListInputs({ ...errorListInputs, formatsObj: !isValid });
    }
  };

  const checkFormByDefault = async () => {
    const inputs: InputTypes[] = [
      'phone',
      'street',
      'city',
      'gender',
      'firstname',
      'name',
      'email',
      'zipcode',
      'nr',
      'orderCompany',
      'spottype',
      'checkboxControl',
    ];

    for (const input of inputs) {
      await validationInput(input)();
    }

    checkFormatsObj();

    return isDisableButton();
  };

  const isErrorClass = (inputName: InputTypes) => (errorListInputs[inputName] ? 'error-input' : '');

  const handleChangeFileInput = (name, fileName, file, removeFile) => {
    const { isDigital } = props;
    const { upload } = stateData;

    if (name !== 'remove') {
      if (file.size > MAX_FILE_SIZE) {
        removeFile();
        return;
      }

      const myFormData = new FormData();
      myFormData.append('it21number', campaign.campaigndata.number);
      myFormData.append('type', isDigital ? '3' : '1');
      myFormData.append('orderfile', file, file.name);

      props.actionsSujet.uploadFile(myFormData).then((res) => {
        if (res && res.data) {
          setStateData({
            ...stateData,
            upload: {
              ...upload,
              [fileName]: {
                urn: res.data.asseturn,
                url: res.data.url,
                size: res.data.filesize,
                type: res.data.mimetype,
                fileName: fileName,
                [formConfig.upload.file.name]: file,
              },
            },
          });
        } else {
          removeFile();
        }
      });
    } else {
      if (upload[fileName] && upload[fileName].urn) {
        props.actionsSujet.deleteUploadedFile({ urn: upload[fileName].urn }).then(() => {
          const newUploads = { ...upload };

          delete newUploads[fileName];
          setStateData({ ...stateData, upload: newUploads });
        });
      }
    }
  };
  const {
    userDataEC: { userInfo },
    isDigital,
    campaignDetails,
    intl,
    loading,
  } = props;
  // let { formatsObj, addressOption, upload } = stateData;
  const addressOptions = prepareAddressOptions();
  const campaignId = params.campaignId;
  const product = campaignDetails ? campaignDetails[campaignId] : null;
  const artOptions = prepareArtsOptions();

  return (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({
          id: 'ec.navigation.gestaltungsKreationsservice',
          defaultMessage: 'Gestaltungs-/Kreationsservice',
        })}
      />
      {isLoading ? (
        <SpinnerV2 />
      ) : (
        <div className='container-fluid journey1 overflow-hidden p-0'>
          <div className='pageContainer'>
            <ErrorContainer journeyType='afterSales' />
            <div className='creationOrder'>
              <div className='row justify-content-start'>
                <h3 className='w-33 mt-3 fw-bold mb-40'>
                  {isDigital ? (
                    <FormattedMessage id='ec.creationOrder.designForSpots' defaultMessage='Gestaltung für Spots' />
                  ) : (
                    <FormattedMessage id='as.creationOrder.title' defaultMessage='Gestaltung für Plakate' />
                  )}
                </h3>
              </div>

              <div className='row justify-content-start'>
                <p className='w-33 mt-3 mb-60'>
                  {isDigital ? (
                    <FormattedMessage
                      id='ec.creationOrder.digital.first-paragraph'
                      defaultMessage='Hauchen Sie Ihrer digitalen Werbung Leben ein und lassen Sie Ihren Spot von einem Profi erstellen.'
                    />
                  ) : (
                    <FormattedMessage
                      id='as.creationOrder.subtitle'
                      defaultMessage='Lassen Sie Ihr Plakat-Sujet von einem unserer Profis gestalten.'
                    />
                  )}
                </p>
              </div>

              <div className='row justify-content-start'>
                {product && (
                  <p className='w-33 mt-3 fw-bold mb-20'>
                    <FormattedMessage
                      id='as.creationOrder.subtitle-paragraph'
                      defaultMessage='Gestaltungs-/Kreationsauftrag zur Kampagne <a></a> erstellen'
                      values={{
                        a: () => (
                          <a
                            rel='noopener noreferrer'
                            href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${product.campaigndata.number}`}
                            target='_blank'
                          >
                            {product.campaigndata.number}
                          </a>
                        ),
                      }}
                    />
                  </p>
                )}
              </div>

              <div className='row justify-content-start'>
                <p className='w-33 mb-24'>
                  {isDigital ? (
                    <FormattedMessage
                      id='as.creationOrder.digital.paragraph'
                      defaultMessage='Lassen Sie Ihren Spot professionell und unkompliziert von unserem Partner erstellen'
                    />
                  ) : (
                    <FormattedMessage
                      id='as.creationOrder.paragraph'
                      defaultMessage='Lassen Sie sich Ihr Plakat von einem unserer professionellen Partnern erstellen. Wählen Sie unten den gewünschten Partner aus und fragen Sie unverbindlich für eine Offerte für die Gestaltung Ihres Plakates an.'
                    />
                  )}
                </p>
              </div>

              <div className='row justify-content-start mb-48'>
                <p className='w-50 w-50 mb-24 fw-bold'>
                  {isDigital ? (
                    <FormattedMessage
                      id='as.creationOrder.digital.whatSpotCreation'
                      defaultMessage='1. Wählen Sie, welche Art von Spot-Kreation Sie wünschen'
                    />
                  ) : (
                    <FormattedMessage
                      id='as.creationOrder.digital.whatSpotCreation'
                      defaultMessage='1. Wählen Sie, welche Art von Spot-Kreation Sie wünschen'
                    />
                  )}
                </p>

                {isDigital ? (
                  <Input
                    inputWrapperClass={'video-input-wrapper w-50 mb-24'}
                    readOnly={false}
                    forcedValue={stateData.spottype}
                    radioOptions={artOptions}
                  />
                ) : (
                  stateData.formatsObj &&
                  Object.keys(stateData.formatsObj).map((formatKey) => (
                    <div
                      key={formatKey + 'formatType'}
                      className='d-flex align-items-center mb-3 mt-3 customCheckbox format-input'
                    >
                      <input
                        required
                        className='ms-3'
                        id={stateData.formatsObj[formatKey].format}
                        type='checkbox'
                        checked={stateData.formatsObj[formatKey].value}
                        onChange={(v) => onChangeFormat(v.target.checked, stateData.formatsObj[formatKey].format)}
                      />

                      <label htmlFor={stateData.formatsObj[formatKey].format}>
                        {stateData.formatsObj[formatKey].format} {getIcon(stateData.formatsObj[formatKey].format)}
                      </label>
                    </div>
                  ))
                )}
              </div>

              {isDigital && (
                <div className='row justify-content-start mb-48'>
                  <p className='w-50 mb-24 fw-bold'>
                    <FormattedMessage
                      id='as.creationOrder.digital.gestaltungWahlen'
                      defaultMessage='2. Format(e) für die Gestaltung wählen'
                    />
                  </p>
                  {stateData.formatsObj && Object.keys(stateData.formatsObj).length}

                  {stateData.formatsObj &&
                    Object.keys(stateData.formatsObj).map((formatKey) => (
                      <div
                        key={formatKey + 'formatType'}
                        className='d-flex align-items-center mb-24 customCheckbox format-input'
                      >
                        <input
                          required
                          className='ms-24'
                          id={stateData.formatsObj[formatKey].format}
                          type='checkbox'
                          checked={stateData.formatsObj[formatKey].value}
                          onChange={(v) => onChangeFormat(v.target.checked, stateData.formatsObj[formatKey].format)}
                        />

                        <label htmlFor={stateData.formatsObj[formatKey].format}>
                          {stateData.formatsObj[formatKey].format}{' '}
                          {getIcon(stateData.formatsObj[formatKey].format.toUpperCase())}
                        </label>
                      </div>
                    ))}
                </div>
              )}

              <div className='row justify-content-start mb-48'>
                <p className='w-33 mb-3 fw-bold'>
                  <FormattedMessage
                    id='as.creationOrder.possibleDocuments'
                    defaultMessage='Mögliche Unterlagen wie Bilder, Logo, Texte etc. hochladen'
                  />
                </p>

                <div className='w-50 d-flex flex-row flex-wrap'>
                  {formConfig.upload.file.visible &&
                    [...Object.keys(stateData.upload), 'new'].map((fileName, idx) => (
                      <Input
                        isFocused
                        type='file'
                        maxLength={10}
                        isLoading={loading.upload}
                        key={`${fileName}${idx}`}
                        inputWrapperClass='file-input file-input--small-rm-btn me-3 mb-4'
                        id={`${fileName}${idx}`}
                        name={`${fileName}${idx}`}
                        file={stateData.upload[fileName] ? stateData.upload[fileName] : null}
                        onChange={handleChangeFileInput}
                      />
                    ))}
                </div>
              </div>

              <div className='row justify-content-start mb-48'>
                <p className='w-33 mb-3 fw-bold'>
                  <FormattedMessage id='as.creationOrder.comments' defaultMessage='Bemerkungen:' />
                </p>

                <div className='w-50 textarea mb-24'>
                  <Input
                    type='textarea'
                    label='label'
                    inputWrapperClass='textarea-input'
                    id='descriptionInput'
                    name='description'
                    placeholder=''
                    value={stateData.textarea}
                    onChange={(name, value) => setStateData({ ...stateData, textarea: value })}
                  />
                </div>
              </div>

              <div className='row user-details justify-content-start mb-48'>
                <p className='w-100 mb-24 fw-bold'>
                  {isDigital ? '4. ' : '3. '}
                  <FormattedMessage
                    id='as.creationOrder.contactDetailsAndOffer'
                    defaultMessage='Kontakt angeben und Offerte anfragen'
                  />
                </p>

                {
                  <div className='w-100'>
                    <Input
                      readOnly={false}
                      forcedValue={stateData.addressOption}
                      radioOptions={addressOptions}
                      inputWrapperClass='horizontalRadios first-radio-narrow'
                      onChange={(name, value) => {
                        setStateData({ ...stateData, addressOption: value });
                      }}
                    />

                    <div className='d-flex ms-5 ps-3'>
                      <div className='w-40 ps-3'>
                        {userInfo && (
                          <div>
                            <p className='m-0'>{userInfo.title}</p>
                            <p className='m-0'>
                              {userInfo.firstname} {userInfo.lastname}
                            </p>
                            <p className='m-0'>{userInfo.address}</p>
                            <p className='mb-3'>
                              {userInfo.zip} {userInfo.city}
                            </p>
                            <p className='m-0'>{userInfo.email}</p>
                            <p className='m-0'>{userInfo.nr}</p>
                          </div>
                        )}
                      </div>

                      <div className='w-60 d-flex ms-3 flex-wrap marginCompensationx2'>
                        <Input
                          id='genderInput'
                          name='genderInput'
                          inputWrapperClass={`w-20 me-3 ${isErrorClass('gender')}`}
                          label='Language'
                          clearable={false}
                          onSelected={(name, value) => {
                            setStateData({ ...stateData, gender: value });
                          }}
                          onBlur={validationInput('gender')}
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.genderHint',
                            defaultMessage: 'Geschlecht',
                          })}
                          value={stateData.gender}
                          selectOptions={[
                            {
                              dropdownLabel: props.intl.formatMessage({
                                id: 'ec.general.mrs',
                                defaultMessage: 'Frau',
                              }),
                              id: props.intl.formatMessage({
                                id: 'ec.general.mrs',
                                defaultMessage: 'Frau',
                              }),
                              value: props.intl.formatMessage({
                                id: 'ec.general.mrs',
                                defaultMessage: 'Frau',
                              }),
                            },
                            {
                              dropdownLabel: props.intl.formatMessage({
                                id: 'ec.general.mr',
                                defaultMessage: 'Herr',
                              }),
                              id: props.intl.formatMessage({
                                id: 'ec.general.mr',
                                defaultMessage: 'Herr',
                              }),
                              value: props.intl.formatMessage({
                                id: 'ec.general.mr',
                                defaultMessage: 'Herr',
                              }),
                            },
                          ]}
                          type='text'
                        />

                        <Input
                          value={stateData.firstname}
                          name={'firstname'}
                          required
                          onChange={(name, value) =>
                            setStateData({
                              ...stateData,
                              firstname: value,
                            })
                          }
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.firstname',
                            defaultMessage: 'Vorname',
                          })}
                          inputWrapperClass={`high w-30 me-3 ${isErrorClass('firstname')}`}
                          onBlur={validationInput('firstname')}
                        />

                        <Input
                          value={stateData.name}
                          required
                          name={'name'}
                          onChange={(name, value) => setStateData({ ...stateData, name: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.name',
                            defaultMessage: 'Name',
                          })}
                          inputWrapperClass={`high w-30 ${isErrorClass('name')}`}
                          onBlur={validationInput('name')}
                        />

                        <Input
                          value={stateData.street}
                          required
                          name={'zipcode'}
                          onChange={(name, value) => setStateData({ ...stateData, street: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.street',
                            defaultMessage: 'Strasse',
                          })}
                          inputWrapperClass={`high w-30 me-2 no-end-padding-input ${isErrorClass('street')}`}
                          onBlur={validationInput('street')}
                        />

                        <Input
                          value={stateData.nr}
                          required
                          name={'nr'}
                          onChange={(name, value) => setStateData({ ...stateData, nr: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.nrHint',
                            defaultMessage: 'Nr.',
                          })}
                          inputWrapperClass={`high w-10 me-2 no-end-padding-input ${isErrorClass('nr')}`}
                          onBlur={validationInput('nr')}
                        />

                        <Input
                          value={stateData.zipcode}
                          required
                          name={'zipcode'}
                          onChange={(name, value) => setStateData({ ...stateData, zipcode: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.zipcodeHint',
                            defaultMessage: 'PLZ',
                          })}
                          inputWrapperClass={`high w-10 me-3 no-end-padding-input ${isErrorClass('zipcode')}`}
                          onBlur={validationInput('zipcode')}
                        />

                        <Input
                          value={stateData.city}
                          required
                          name={'city'}
                          onChange={(name, value) => setStateData({ ...stateData, city: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.ortHint',
                            defaultMessage: 'Ort',
                          })}
                          inputWrapperClass={`high w-30 ${isErrorClass('city')}`}
                          onBlur={validationInput('city')}
                        />

                        <Input
                          value={stateData.email}
                          required
                          name={'address'}
                          onChange={(name, value) => setStateData({ ...stateData, email: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.email',
                            defaultMessage: 'E-Mail',
                          })}
                          inputWrapperClass={`high w-51-7 me-3 ${isErrorClass('email')}`}
                          onBlur={validationInput('email')}
                        />

                        <Input
                          value={stateData.phone}
                          required
                          name={'city'}
                          onChange={(name, value) => setStateData({ ...stateData, phone: value })}
                          type='text'
                          placeholder={props.intl.formatMessage({
                            id: 'ec.forms.phone',
                            defaultMessage: 'Telefon',
                          })}
                          inputWrapperClass={`high w-30 ${isErrorClass('phone')}`}
                          onBlur={validationInput('phone')}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div className='row justify-content-start'>
                <p className='w-33 my-24 fw-bold'>
                  {isDigital ? (
                    <>
                      4.{' '}
                      <FormattedMessage
                        id='ec.checkout.gestaltungsauftragErteilen'
                        defaultMessage='Gestaltungsauftrag erteilen'
                      />
                    </>
                  ) : (
                    <>
                      4.{' '}
                      <FormattedMessage
                        id='ec.checkout.druckauftrageErteilen'
                        defaultMessage='Druckauftrage erteilen'
                      />
                    </>
                  )}
                </p>
                <div className='d-flex customCheckbox mb-4'>
                  <input
                    id='abg'
                    name='abg'
                    type='checkbox'
                    className='mt-3'
                    checked={stateData.checkboxControl}
                    onChange={(e) => {
                      const val = e.target.checked;
                      setStateData({ ...stateData, checkboxControl: val });
                      setErrorListInputs({ ...errorListInputs, checkboxControl: !val });
                    }}
                  />
                  <label className='w-33 ms-0' htmlFor='abg'>
                    {isDigital ? (
                      <>
                        <FormattedMessage
                          defaultMessage='Hiermit bestätige ich, dass ich die APG|SGA zusammen mit einer Partneragentur beauftrage, die Gestaltung meiner Spots umzusetzen.'
                          id='ec.productionOrder.checkboxLabelDigital'
                        />
                        <br />
                        <FormattedMessage
                          defaultMessage='Wichtig: Die Abwicklung und die Verrechnung wird direkt zwischen dem Kunden und der Partneragentur abgewickelt.'
                          id='ec.productionOrder.checkboxLabelDigitalTwo'
                        />
                      </>
                    ) : (
                      <>
                        <FormattedMessage
                          defaultMessage='Hiermit bestätige ich, dass ich die APG|SGA zusammen mit einer Partneragentur beauftrage, die Gestaltung meiner Spots umzusetzen.'
                          id='ec.productionOrder.checkboxLabelDigital'
                        />
                        <br />
                        <FormattedMessage
                          defaultMessage='Wichtig: Die Abwicklung und die Verrechnung wird direkt zwischen dem Kunden und der Partneragentur abgewickelt.'
                          id='ec.productionOrder.checkboxLabelDigitalTwo'
                        />
                      </>
                    )}
                  </label>
                </div>
              </div>
              <div className='row justify-content-start mb-48'>
                <div className='w-100 d-flex twoButtons'>
                  <Button
                    onClick={() =>
                      navigate({
                        pathname: '/campaign/' + campaignId,
                      })
                    }
                    buttonType={EButtonType.InvertedPillMedium}
                  >
                    <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
                  </Button>

                  <Button
                    isDisabled={isDisableButton()}
                    onClick={postCreationOrder}
                    isLoading={loading['order']}
                    buttonType={EButtonType.PillMedium}
                    className={'ms-3'}
                  >
                    <FormattedMessage id='ec.components.buttons.confirm' defaultMessage='Bestätigen' />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreationOrder)));
